 angular
   .module('vppApp')
   .provider('scrollToOptions', scrollToOptions);

 function scrollToOptions() {
   this.options = {
     handler: function(el, offset) {
       if (offset) {
         var top = $(el).offset().top - offset;
         window.scrollToDirective(0, top);
       } else {
         var navHeight = document.getElementsByClassName('nav-margins');
         navHeight = navHeight[0].clientHeight;
         el.scrollIntoView(true);
         window.scrollTo(0, el.offsetTop - navHeight);

       }
     }
   };
   this.$get = function() {
     return this.options;
   };
   this.extend = function(options) {
     this.options = angular.extend(this.options, options);
   };
 };
